<template>
  <div class="invest-main">
    <div class="step">
      <van-steps :active="active" active-color="#38f">
        <van-step>登录商城</van-step>
        <van-step>输入卡号</van-step>
        <van-step>输入卡密</van-step>
        <van-step>激活成功</van-step>
      </van-steps>
    </div>
    <div class="card">
      <div class="title">温馨提示：</div>
      <p>1.如果您激活的为积分卡：</p>
      <p>(1) 您充值到账户里的积分自激活之日起1年内有效，请尽快使用</p>
      <p>
        (2) 您的积分卡一旦被激活，将充值到<span
          >当前登录的账户内，请牢记并妥善保管您的账号和密码。</span
        >
      </p>
      <p>
        2.如果您激活的为积分定制卡，您的定制卡一旦被激活，有效期为30天，只可兑换对应礼品，请根据提示进行兑换。
      </p>
      <p>
        3.无卡用户如果想要获取积分卡或者定制卡，请关注海尔各个销售渠道的营销活动，可现场了解获取详情。
      </p>
    </div>
    <div class="investinput">
      <!-- <div>请输入您的积分卡号：</div> -->
      <!-- <input type="text" class="input" v-model="cardNo" @blur="validPhone()" /> -->
      <van-field v-model="cardNo" label="积分卡号：" />
      <!-- <div class="btn" >下一步</div> -->
      <van-button round type="primary" @click="pointCardExit"
        >下一步</van-button
      >
    </div>
  </div>
</template>

<script>
import { getPointCardExit } from "@/api/api";
export default {
  data() {
    return {
      active: 1,
      cardNo: null,
      hbscToken:null,
    };
  },

  methods: {
    async cs() {
    debugger
   let url = "https://jf.haier.com/m/?token=1321565163";
               
 if (url != null && url.indexOf("token") > -1) {
                    let hbscToken = url.match(/token=(\S*)&/);
                    this.hbscToken = hbscToken[1];
                    this.$cookies.set("hbscToken", this.hbscToken);
                    // alert(this.redirecturis)
                    this.getUserInfo();
                }
    },
  },

  mounted() {
    this.cs();
  },
};
</script>

<style lang="scss" scoped>
/deep/.van-button--normal {
  width: 80%;
  display: block;
  margin: 0 auto;
  margin-top: 50px;
}
.step {
  background-color: #fff;
}

/deep/.van-steps--horizontal {
  width: 80%;
  margin: 0 auto;
}

.card {
  background-color: #fff;

  padding-top: 50px;

  .title {
    text-align: center;
    font-size: 35px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  p {
    width: 600px;
    margin: 0 auto;
    font-size: 28px;
    line-height: 50px;

    span {
      color: red;
    }
  }
}

.investinput {
  // display: flex;
  align-items: center;
  // justify-content: center;
  background-color: #fff;
  padding-top: 50px;

  .input {
    width: 230px;
    height: 60px;
    padding-left: 10px;
    border: 1px solid rgb(182, 174, 174);
    margin-left: 10px;
    margin-right: 15px;
  }

  .btn {
    width: 130px;
    height: 60px;
    line-height: 60px;
    background-color: #2283e2;
    text-align: center;
    color: white;
    cursor: pointer;
  }
}
</style>
